import "./App.css";
import Form from "../pages/Form.js";
import Submitted from "../pages/Submitted.js";
import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import Confirm from "../pages/Confirm.js";
import Error from "../pages/Error.js";
import NotFound from "../pages/NotFound.js";
import { Box } from "@mui/material";
import { UserDialog } from "../pages/UserDialog.js";
import ButtonAppBar from "../components/Navbar.js";
import HeroForm from "../pages/HeroForm.js";
import { AboutUsHero } from "../pages/AboutUs.js";
import {
  ForgotPasswordConfirmation, ResetPasswordExpired,
  ResetPasswordForm,
  ResetPasswordSuccess
} from "../pages/ForgotPassword.js";
import { Audiences } from "../pages/Audiences.js";
const isHero = process.env.REACT_APP_HERO === "true";

function App() {

  const [submitted, setSubmitted] = useState(false);
  const [start, setStart] = useState(false);
  const [loginStatus, setLoginStatus] = useState({ auth: false, email: null, token: null });
  const navigate = useNavigate();

  // const [focus, setFocus] = useState(false);

  useEffect(() => {
    return () => {
      window.onbeforeunload = function() {
        window.scrollTo(0, 0);
      };
    };
  });

  useEffect(() => {
    //Fetch auth here
    if (localStorage.token && localStorage.email) {
      setLoginStatus({ auth: true, email: localStorage.email, token: localStorage.token });
    }

  }, []);

  const updateLoginStatus = (status) => {
    setLoginStatus(status);
  };

  const finishSubmitting = () => {
    setSubmitted(!submitted);
  };

  const clickedStart = () => {
    setStart(!start);
  };

  return (
    <Box>
      <ButtonAppBar title={isHero ? "" : "TREBLE"}> <UserDialog loginStatus={loginStatus} updateLogin={updateLoginStatus}/> </ButtonAppBar>

      <Routes>
        {!submitted &&
        <Route exact path="/" element={
          (isHero ?
            <HeroForm
            loginStatus={loginStatus}
            setLoginStatus={setLoginStatus} />
              :
            <Form
            loginStatus={loginStatus}
            setLoginStatus={setLoginStatus} />
          )
        }
        />
        }
        {submitted &&
        <Route exact path="/" element={<Submitted />} />
        }
        <Route path="/confirm/:id" element={<Confirm />} />
        <Route path="/forgot-password/success" element={<ResetPasswordSuccess />} />
        <Route path="/forgot-password/expired" element={<ResetPasswordExpired />} />
        <Route path="/forgot-password/:id" element={<ResetPasswordForm />} />
        <Route path="/forgot-password" element={<ForgotPasswordConfirmation />} />
        {isHero &&<Route path="/about" element={<AboutUsHero />} />}
        <Route path="/error" element={<Error />} />
        <Route path="/thanks" element={<Submitted />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/audiences" element={<Audiences loginStatus={loginStatus}
                                                       setLoginStatus={setLoginStatus}  />} />
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />
      </Routes>

    </Box>
  );

}

export default App;
